import http from 'axios'
import { cacheAdapterEnhancer } from 'axios-extensions';
import { useConfig } from '@/helpers/config'

const API_URL =  ( useConfig().API_URL || '' ) + '/wp-json/adelya/v1';

export default http.create({
    baseURL: API_URL,
    adapter: cacheAdapterEnhancer(http.defaults.adapter)
});